import React from 'react'
import { Switch, Redirect } from 'react-router-dom'

import { PATHS } from '@/consts/paths'
import { useProfile } from '@/hooks/index'

import AdminRoutes from './admin.routes'
import CarrierRoutes from './carrier.routes'
import RepresentativeRoutes from './representative.routes'
import CommonRoutes from './common.routes'

import Route from './Route'
import { company } from '@/consts/types'
import CustomerRoutes from './customer.routes'

export function ContentRoutes() {
  const profile = useProfile()

  const companyType = profile.web_company?.wee_tipo

  const userType = profile.weu_tipo

  function renderRoutes() {
    return (
      <>
        {companyType === company.TRANSPORTADORA && <CarrierRoutes />}
        {companyType === company.REPRESENTANTE && <RepresentativeRoutes />}
        {companyType === company.CLIENTE && <CustomerRoutes />}

        {profile.isAdminUser && <AdminRoutes companyType={companyType} />}

        <CommonRoutes />

        <Route
          path={PATHS.root || '/'}
          exact
          isPrivate
          component={() => (
            <Redirect to={PATHS.defaultPath(companyType, userType)} />
          )}
        />
      </>
    )
  }

  return <Switch>{renderRoutes()}</Switch>
}

export default ContentRoutes
